module.exports = __webpack_public_path__ + "static/media/sc3.dcd68b88.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/sc3.png
// module id = 108
// module chunks = 0